import config from "@/styles/utils/responsive.export.module.scss";

export const mediaQueries = {
  medium: +config.medium,
  big: +config.big,
  large: +config.large,
};
